import { ReactNode } from "react";
import {
  Box,
  Paper,
  Stack,
  SxProps,
  Theme,
  Typography,
  useTheme,
} from "@mui/material";

interface SectionCardProps {
  icon?: ReactNode;
  title?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  sx?: SxProps<Theme>;
}

/**
 * Paper card with the app's gradient title bar (same gradient as
 * StyledAccordionSummary) so form fields and headings stay readable on the
 * dashboard's background image.
 */
export const SectionCard = ({
  icon,
  title,
  action,
  children,
  sx,
}: SectionCardProps) => {
  const theme = useTheme();
  return (
    <Paper
      elevation={3}
      sx={{ mb: 2, borderRadius: "8px", overflow: "hidden", ...sx }}
    >
      {title && (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          flexWrap="wrap"
          sx={{
            px: 2,
            py: 1,
            backgroundImage: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 60%, ${theme.palette.primary.light} 100%)`,
            color: "common.white",
          }}
        >
          <Stack direction="row" spacing={1} alignItems="center">
            {icon}
            <Typography variant="h6" component="div">
              {title}
            </Typography>
          </Stack>
          {action}
        </Stack>
      )}
      <Box sx={{ p: 2 }}>{children}</Box>
    </Paper>
  );
};
